<template>
  <div class="px-10">
    <el-form
      label-position="left"
      label-width="6rem"
      :model="form"
      :rules="rules"
      ref="ruleForm"
    >
      <el-form-item
        :label="$t('手机号')"
        prop="phone"
        v-if="vertifyMessage === 'phone'"
      >
        <el-input v-model="form.phone" disabled></el-input>
      </el-form-item>
      <el-form-item
        :label="$t('邮箱')"
        prop="email"
        v-if="vertifyMessage === 'email'"
      >
        <el-input v-model="form.email" disabled></el-input>
      </el-form-item>
      <el-form-item :label="$t('验证码')" prop="code">
        <el-input v-model="form.code" :placeholder="$t('验证码')">
          <template slot="append">
            <span @click="sendCode" v-if="code_show">{{
              $t("发送验证码")
            }}</span>
            <span v-else>{{ $t("等待") + count }}s</span>
          </template>
        </el-input>
      </el-form-item>
      <el-form-item :label="$t('新密码')" prop="password">
        <el-input
          v-model="form.password"
          :placeholder="$t('新密码')"
          show-password
        ></el-input>
      </el-form-item>
      <el-form-item class="text-right">
        <el-button @click="changeCancel">{{ $t("取消") }}</el-button>
        <el-button type="primary" @click="confirm">{{ $t("确认") }}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { ref, reactive, watchEffect, computed } from "@vue/composition-api";
import bus from "@/API/util/bus.js";
export default {
  props: {
    data: String,
  },
  setup(props, ctx) {
    const vertifyMessage = ref();
    watchEffect(() => {
      vertifyMessage.value = props.data;
    });
    //用户信息
    const user = computed(() => ctx.root.$store.getters.user);

    const form = reactive({
      phone: user.value.phone || ctx.root.$t("用户暂未绑定手机号"),
      email: user.value.email || ctx.root.$t("用户暂未绑定邮箱"),
      code: "",
      password: "",
    });
    const rules = {
      phone: [{ required: true }],
      email: [{ required: true }],
      code: [
        {
          required: true,
          message: ctx.root.$t("请输入验证码"),
          trigger: "blur",
        },
        {},
      ],
      password: [
        {
          required: true,
          message: ctx.root.$t("请输入新密码"),
          trigger: "blur",
        },
      ],
    };

    //发送验证码
    const count = ref(Number(0));
    const code_show = ref(true);
    const whenSendcode_phone = () => {
      ctx.root.$doing(ctx.root.$t("验证码已发送"));
      code_show.value = false;
      ctx.root.$done();
      const countDown = 60;
      count.value = countDown;
      const timer = setInterval(() => {
        if (count.value > 0 && count.value <= 60) {
          count.value--;
        } else {
          code_show.value = true;
          clearInterval(timer);
        }
      }, 1000);
    };

    const sendCode = () => {
      if (vertifyMessage.value === "phone" && user.value.phone) {
        ctx.root
          .$callapi("sendVerifyPhone", {
            phone: user.value.phone,
            usetype: "resetpassword",
          })
          .then(() => {
            whenSendcode_phone();
          });
      } else if (vertifyMessage.value === "phone") {
        ctx.root.$toast(ctx.root.$t("未绑定手机号"));
      } else if (vertifyMessage.value === "email" && user.value.email) {
        ctx.root
          .$callapi("sendVerifyEmail", {
            email: user.value.email,
            usetype: "resetpassword",
          })
          .then(() => {
            whenSendcode_phone();
          });
      } else {
        ctx.root.$toast(ctx.root.$t("未绑定邮箱"));
      }
    };
    //修改请求
    const reset = async (e) => {
      ctx.root.$doing();
      await ctx.root
        .$callapi("user/resetPassword", {
          password: form.password,
          verifycode: form.code,
          origin: e,
        })
        .then((res) => {
          ctx.root.$done();
          if (res.code == 0) {
            bus.emit("changeSuccess");
            ctx.root.$toast(ctx.root.$t("修改密码成功"), "success");
          }
        });
    };
    //确认修改
    const confirm = () => {
      const obj = {
        phone: "手机号",
        email: "邮箱",
      };
      ctx.refs.ruleForm.validate((valid) => {
        if (valid) {
          if (
            user.value[vertifyMessage.value] &&
            vertifyMessage.value == "phone"
          ) {
            reset("phone");
          } else if (
            user.value[vertifyMessage.value] &&
            vertifyMessage.value == "email"
          ) {
            reset("email");
          } else {
            ctx.root.$toast(ctx.root.$t("未绑定" + obj[vertifyMessage.value]));
          }
        } else {
          return false;
        }
      });
    };

    //取消修改
    const changeCancel = () => {
      bus.emit("changeCancel");
    };
    return {
      form,
      rules,
      sendCode,
      confirm,
      count,
      code_show,
      vertifyMessage,
      changeCancel,
    };
  },
};
</script>
<style lang="scss" scoped>::v-deep .el-form-item__label {
  overflow: hidden;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
  white-space: nowrap;
}</style>
